export default __webpack_public_path__ + "static/media/Facilities Only - Grey.e7d83197.svg";